import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import MyClients from '../../components/rep/MyClients';

const MyClientsPage = ({ currentUser }) => {
  return (
    <Box
      sx={{
        pt: { xs: 7, md: 3 },
        minHeight: '100vh',
        maxWidth: '1400px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: 700, 
          mb: 4, 
          color: '#212121',
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        My Clients
      </Typography>
      
      <Card sx={{ boxShadow: 'none', border: '1px solid #ececef' }}>
        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
          <MyClients />
        </CardContent>
      </Card>
    </Box>
  );
};

export default MyClientsPage;

